import React from 'react';
import Header from './Header';

const About = () => {
    return (
        <>
        <Header/>
        <section className="about-section">
            <h2>About/ Disclaimer</h2>
            <p>
                This website is designed purely for knowledge-sharing purposes. The content presented here may include references
                to other publicly available resources or code snippets that could be copyrighted. However, the owner of this website
                does not intend to profit from this content. The goal is solely to spread knowledge and provide educational material.
            </p>
            <p>
                As the owner, there are no obligations to any individual, and this website is not a monetary venture. No legal action
                can be taken as this site is not intended to generate profit in any form.
            </p>
            <p>
                Please use the content responsibly, and feel free to share it for educational purposes. Your understanding and respect
                for these terms is greatly appreciated.
            </p>
        </section>
        </>
    );
};

export default About;
